import Ajax from "Utils/ajax";
export const getAllReleaseNotes = (data) => Ajax.post('hr/getAllReleaseNotes',data);
export const addReleaseNote = (data) => Ajax.post('hr/addReleaseNote',data);
export const getReleaseNote = (data) => Ajax.post('hr/getReleaseNote',data);